<div class="sync-fusion-main-container">
  <app-header-content-help-text [Heading]="reportNameWithSpace" [helpText]="tagline"
    (printClicked)="handleHeaderPrintClick()" [showFilterButton]="showFilter"
    (filterButtonClicked)="toggleFilterOverlay()"></app-header-content-help-text>
  <div *ngIf="generatedDate" class="fs-hint-text flex-end fs-margin-0-1"><span>Reports are generated as on
      <strong>{{generatedDate |
        date}}</strong></span></div>
  <div *ngIf="reportLabelText" class="fs-hint-text flex-end fs-margin-0-1"><span>** {{reportLabelText}}</span></div>
  <ng-container *ngIf="tableDataFetched && appliedFilters">
    <app-filter-bay-reusable *ngIf="appliedFilters" [addFilters]="appliedFilters"></app-filter-bay-reusable>
  </ng-container>
  <div [ngClass]="dateFilterRequired ? '' : 'grid-container'"
    [ngStyle]="{'width': (dynamic_headers.length <= 5 && !dateFilterRequired) ? '90%' : '100%', 
  'margin': (dynamic_headers.length <= 5 && !dateFilterRequired )? '0 auto' : '0', 'height': dateFilterRequired ? '76%' : ''}">
    <div *ngIf="dateFilterRequired" class="date-range-picker">
      <mat-form-field appearance="outline">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
          <input matStartDate formControlName="start" placeholder="Start date">
          <input matEndDate formControlName="end" placeholder="End date">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker (closed)="onDateRangeSelected()"></mat-date-range-picker>

        <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
        <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
      </mat-form-field>
      <div class="text-icon-container" *ngIf="!selectedDateRange">
        <mat-icon>add_box</mat-icon>
        <p>Select date range to get product insights</p>
      </div>
    </div>
    <!-- <app-syncfusion-grid #gridRef [reportName]="reportName" [dynamic_headers]="dynamic_headers" [count]="count" [data]="data"
      *ngIf="tableDataFetched" (dataEmitForPOPUP)="handlePOPUP($event)"
      (navigateGrid)="navigateGrid($event)"></app-syncfusion-grid> -->
    <app-grid-reusable-molecule #gridRef [reportName]="reportName" [dynamic_headers]="dynamic_headers" [count]="count"
      [data]="data" *ngIf="(!dateFilterRequired || selectedDateRange) && tableDataFetched"
      (dataEmitForPOPUP)="handlePOPUP($event)" (navigateGrid)="navigateGrid($event)"></app-grid-reusable-molecule>
  </div>

  <app-popup-reuse-organsim *ngIf="fieldData && headerData" [showPOPUP]="visiblePOPUP" [fieldData]="fieldData"
    [headerData]="headerData" (POPUPFeedback)="visiblePOPUP=$event"></app-popup-reuse-organsim>

  <app-reusable-filter-molecule #childFilter *ngIf="filterData" [showFiltersPopup]="showFiltersPopup"
    [reportName]="reportName" [filterData]="filterData" (filterPopupClosed)="showFiltersPopup = $event"
    (filtersApplied)="handleFilterOutput($event)"
    (displayFilters)="selectedFilters($event)"></app-reusable-filter-molecule>
</div>